import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { MasterService } from '@app/utility/master.service';
import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from 'rxjs';
import { AuthService } from '@app/auth.service';
import { timer } from 'rxjs/observable/timer'
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { E } from '@angular/core/src/render3'; 
import { ElementSchemaRegistry } from '@angular/compiler';

declare var $: any, moment: any;

@Component({
  selector: 'app-refund-deposits',
  templateUrl: './refund-deposits.component.html',
  styleUrls: ['./refund-deposits.component.scss']
})
export class RefundDepositsComponent implements OnInit {

  constructor(
    private Api: ApiService,
    private Util: UtilService,
    private MasterService: MasterService,
    private router: Router,
    private translate: TranslateService
  ) { }

  Profile: any;
  Ticket: any;
  Contact: any;
  ContactDros: any;
  Editable: Boolean = false;
  CompanyType: any;
  PersonalType: any;
  DocGroupList: any;
  FileList: any = [];
  DocumentList: any = [];
  AcceptExtension: any;
  MaxTotalSizeMB: number;
  TotalFileSize: number = 0;
  InvestigateFlag: Boolean = false;
  AppealFlag: Boolean = false;

  PortalUser: any;

  OTPRefCode: string = "";
  ElapseTime: number = 0;
  TotalTime: number = 0;
  SubScr: Subscription;
  WaitTime: number;
  SubScr2: Subscription;

  masterStatus: any

  menuEnabled = false
  otpSkip = false
  drosWeb: string = "";
  PathPdf: string = "";

  OtpFlag: any

  async ngOnInit() {
    try {

      this.Util.ShowWaiting(true)

      let config: any = await this.Api.get("master", "configuration")
      let crisisConfig: any = config.filter((c: any) => {
        return c.dpa_name == "CRISIS FLAG"
      })

      let otpConfig = config.filter((c: any) => {
        return c.dpa_name == "OTP"
      })

      let isCrisis: any
      if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
        isCrisis = true
      }
      else {
        isCrisis = false
      }

      if (otpConfig != null && otpConfig.length > 0 && otpConfig[0].dpa_crisisflag != null && otpConfig[0].dpa_crisisflag == true) {
        this.OtpFlag = true
      }
      else {
        this.OtpFlag = false
      }


      let menuList: any = await this.Api.get("master", "customerPortalMenuSetting")
      let thisMenu: any = this.Util.getMenuObj(menuList, "06", isCrisis)
      if (!thisMenu.show) {
        this.Util.ShowWaiting(false)
        setTimeout(() => {
          this.router.navigate(["mainmenu/index"])
        }, 500);
        return
      }
      else {
        this.menuEnabled = true
      }

      this.PortalUser = JSON.parse(localStorage.getItem("dpa_portal"));
      let thisTs = this;

      if (this.PortalUser == null || this.PortalUser.contactid == null || this.PortalUser.contactid == "") {
        this.Util.WarningDialog("กรุณาเข้าสู่ระบบ");
        $("#btnWarningOK").off("click");
        $("#btnWarningOK").click(function () {
          thisTs.router.navigate(["/mainmenu/login"]);
        });
        return;
      }
      else {
        let userDetail: any = await this.Api.get("crmservice", "contact", "contactid=" + this.PortalUser.contactid)

        $("#FirstNameDOPA").val(userDetail[0].firstname)
        $("#LastNameDOPA").val(userDetail[0].lastname)
        $("#IDNoDOPA").val(userDetail[0].dpa_idcard)

        if (userDetail[0].birthdate != null && userDetail[0].birthdate != "") {
          let dob: any = new Date(userDetail[0].birthdate.replace("z", ""))
          dob.setFullYear(dob.getFullYear() + 543)
          $("#BirthDateDOPA").val(moment(dob).format('DD/MM/YYYY'))
        }
        else {
          $("#BirthDateDOPA").val("")
        }

      }

      // boy add
        
      let para = "dpaCode=PRIVACY_POLICY";
      let tmp: any = await this.Api.get("crmservice", "getPolicy", para); 
      if(!this.Util.IsNullOrUndefined(tmp.policyDetail))
        {
          $("#refPolicy").html(tmp.policyDetail);
        }
      // boy add

      this.Profile = await (this.Api.getCustomAPI("User", "GetUser", "username=" + this.PortalUser.email));
      if (this.Profile != null) {
        this.Profile = this.Profile;
        this.Contact = await (this.Api.get("crmservice", "contact", "contactid=" + this.Profile.customerid));
        this.Contact = this.Contact[0];

        this.masterStatus = await this.Api.get("master", "approvalStatus")

        this.Ticket = await (this.Api.get("crmservice", "searchApprovalTicket", "contactid=" + this.Profile.customerid));
        let para = "CRM02=true&CRM03=true&CRM04=true&CRM05=true&CRM06=true&CRM07=true"
        if (this.Contact.dpa_idcard != null) {
          para += "&dpa_id=" + this.Contact.dpa_idcard
        }
        else if (this.Contact.dpa_passport != null) {
          para += "&dpa_id=" + this.Contact.dpa_passport
        }
        else if (this.Contact.dpa_registrationid != null) {
          para += "&dpa_id=" + this.Contact.dpa_registrationid
        }

        this.ContactDros = await this.Api.get("crmservice", "contactDros", para)
        this.Util.ShowWaiting(false)
        if (this.Ticket.length > 1) {
          let LastDate: Date;
          let TmpTicket: any;
          this.Ticket.forEach((a: any) => {
            if (LastDate == null || LastDate == undefined) {
              LastDate = new Date(a.dpa_submitdate);
              TmpTicket = a;
            }
            else {
              if (LastDate < new Date(a.dpa_submitdate)) {
                LastDate = new Date(a.dpa_submitdate);
                TmpTicket = a;
              }
            }
          });
          this.Ticket = TmpTicket;
        }
        else if (this.Ticket.length == 1) {
          this.Ticket = this.Ticket[0];
        }
        else {
          this.Ticket = {
            dpa_approvalticketid: null,
            dpa_name: null,
            dpa_contactid: this.Contact.contactid,
            dpa_contactidname: this.Contact.firstname + (this.Contact.lastname == null ? "" : (" " + this.Contact.lastname)),
            dpa_submitdate: new Date().toISOString().substring(0, 10),
            dpa_originalsource: 1,
            dpa_remark: null,
            dpa_approvalstatuscode: '01',
            dpa_approvalstatusid: thisTs.GetStatusGuidByCode("01"),
            dpa_documentchecklist: "",
            attachfilelist: [],
            dpa_idcard: this.Contact.dpa_idcard,
            dpa_passport: this.Contact.dpa_passport,
            dpa_registrationid: this.Contact.dpa_registrationid,
            dpa_authorizedperson: this.Contact.dpa_authorizedperson,
            dpa_authorizedperson_idcard: this.Contact.dpa_authorizedperson_idcard,
            dpa_personaltypeid: this.Contact.dpa_personaltypeid,
            dpa_personaltypeidname: this.Contact.dpa_personaltypeidname,
            dpa_companytypeid: this.Contact.dpa_companytypeid,
            dpa_companytypeidname: this.Contact.dpa_companytypeidname,
            dpa_attachsizing: 0,
            emailaddress1: this.Contact.emailaddress1,
            telephone1: this.Contact.telephone1 == null ? this.Contact.dpa_authorizedperson_telephone : this.Contact.telephone1
          }
        }

        // Foer test purpose
        // this.Ticket.dpa_status = 1;
        // this.Contact.dpa_companytypeid = null;
        // this.Contact.telephone1 = this.Contact.dpa_authorizedperson_telephone;
        //this.Contact.dpa_personaltypeidname = "ต่างชาติ";
        ///////////////////////////////

        let State: any = await this.GetState();
        const objSession = JSON.parse(localStorage.getItem('oneOTP'));
        if (objSession != null){
        //if (this.Contact.dpa_companytypeid != null && this.Contact.dpa_companytypeid != "") {
          //if (this.Ticket.dpa_approvalstatuscode == '01' || this.Ticket.dpa_approvalstatuscode == '02') {
          //  $("#divStart").removeClass("sr-only");
          //  //$("#imgBtn").addClass("btn-img-1");
          //  $("#imgBtn").attr("src", "../../assets/images/receive_deposit_1.png");
          //  let v: any = this.translate.get("Verifiaction identity at agent bank")
          //  $("#BtnLabel").html(v.value);
          //  if (this.Ticket.dpa_approvalticketid == null) {
          //    this.Editable = true;
          //    $("#divDocList").removeAttr("disabled");
          //    $("#divUpload").removeClass("sr-only");
          //    $("#btnSendData").removeClass("sr-only");
          //  }
          //  else {
          //    this.Editable = false;
          //    $("#divDocList").attr("disabled", "disabled");
          //    $("#divUpload").addClass("sr-only");
          //  }
         // }
          //else if (this.Ticket.dpa_approvalstatuscode == '05' || this.Ticket.dpa_approvalstatuscode == '06') {
          //  $("#divStart").removeClass("sr-only");
          //  //$("#imgBtn").addClass("btn-img-2");
          //  $("#imgBtn").attr("src", "../../assets/images/receive_deposit_2.png");
          //  $("#btnSendData").removeClass("sr-only");
           // if (this.Ticket.dpa_approvalstatuscode == '06') {
           //   $("#divDocList").removeAttr("disabled");
           //   $("#divUpload").removeClass("sr-only");
           //   this.Editable = true;
           // }

           // let v: any = this.translate.get("Revise documents")
           // $("#BtnLabel").html(v.value);
         // }
         // else if (this.Ticket.dpa_approvalstatuscode == '03') {
            //let v: any = this.translate.get("Verifiaction by OTP")
            //$("#divStart").removeClass("sr-only");
            ////$("#imgBtn").addClass("btn-img-3");
            //$("#imgBtn").attr("src", "../../assets/images/receive_deposit_3.png");
            //$("#BtnLabel").html(v.value);
         // }
          
          // boy Add
          let v = localStorage.getItem("verifyIdentity");
          if (v == "true"){
            thisTs.Util.ShowWaiting(true);
            thisTs.Contact.dpa_allowemail = true;
            thisTs.Contact.dpa_allowsms = thisTs.Contact.dpa_allowemail;
            await thisTs.Api.post("crmservice", "contact", thisTs.Contact);
  
            //$("#divCondition").addClass("sr-only");
            await thisTs.ShowBankList();
            this.Util.ShowWaiting(false);
            //thisTs.Util.ShowWaiting(false);
            //$("#divStart2").removeClass("sr-only");
          }
          else if (thisTs.Contact.dpa_thaidflag != null && thisTs.Contact.dpa_thaidflag == true &&
            thisTs.Contact.dpa_thaidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)){
              
              thisTs.Util.ShowWaiting(true);
              thisTs.Contact.dpa_allowemail = true;
              thisTs.Contact.dpa_allowsms = thisTs.Contact.dpa_allowemail;
              await thisTs.Api.post("crmservice", "contact", thisTs.Contact);
    
              await thisTs.ShowBankList();
              this.Util.ShowWaiting(false);
            }
          else if (thisTs.Contact.dpa_ndidflag != null && thisTs.Contact.dpa_ndidflag == true &&
            thisTs.Contact.dpa_ndidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)){
              
              thisTs.Util.ShowWaiting(true);
              thisTs.Contact.dpa_allowemail = true;
              thisTs.Contact.dpa_allowsms = thisTs.Contact.dpa_allowemail;
              await thisTs.Api.post("crmservice", "contact", thisTs.Contact);
    
              await thisTs.ShowBankList();
              this.Util.ShowWaiting(false);
            }
          else {
            //thisTs.Util.ShowWaiting(true);
            //thisTs.Contact.dpa_allowemail = true;
            //thisTs.Contact.dpa_allowsms = thisTs.Contact.dpa_allowemail;
            //await thisTs.Api.post("crmservice", "contact", thisTs.Contact);
  
            //$("#divCondition").addClass("sr-only");
            //await thisTs.ShowBankList();
            //thisTs.Util.ShowWaiting(false);
            $("#divStart2").removeClass("sr-only");
          }
          // boy Add
        }
        else {

          if (this.OtpFlag == true){
            let v: any = this.translate.get("Personal type")
            $("#divOTP").removeClass("sr-only");
            $("#CustomerType").html(v.value);
            $("#divCompanyName").addClass("sr-only");
            $("#divTaxID").addClass("sr-only");
            v = this.translate.get("Name")
            $("#lblFirstName").html(v.value);
            v = this.translate.get("Surname")
            $("#lblLastName").html(v.value);
            $("#PhoneNo").html(this.Contact.telephone1);
  
            if (this.Ticket.dpa_approvalstatuscode == '01' || this.Ticket.dpa_approvalstatuscode == '02') {
              if (this.Ticket.dpa_approvalticketid == null) {
                this.Editable = true;
                $("#divDocList").removeAttr("disabled");
                $("#divUpload").removeClass("sr-only");
                $("#btnSendData").removeClass("sr-only");
              }
              else {
                $("#divDocList").attr("disabled", "disabled");
                $("#divUpload").addClass("sr-only");
              }
            }
            else if (this.Ticket.dpa_approvalstatuscode == '05' || this.Ticket.dpa_approvalstatuscode == '06') {
              $("#btnSendData").removeClass("sr-only");
              if (this.Ticket.dpa_approvalstatuscode == '06') {
                $("#divDocList").removeAttr("disabled");
                $("#divUpload").removeClass("sr-only");
                this.Editable = true;
              }
            }
          } else{
            localStorage.setItem("oneOTP", JSON.stringify(this.Contact))
            $("#divOTP").addClass("sr-only");
            this.SetState("skipotp");
            if (this.Contact.dpa_companytypeid != null && this.Contact.dpa_companytypeid != "" ||
              (this.Contact.dpa_dopaflag != null && this.Contact.dpa_dopaflag == true && this.Contact.dpa_dopaagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)) ||
              (this.Contact.dpa_ndidflag != null && this.Contact.dpa_ndidflag == true && this.Contact.dpa_ndidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)) ||
              (this.Contact.dpa_thaidflag != null && this.Contact.dpa_thaidflag == true && this.Contact.dpa_thaidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10))) 
              { //นิติบุคคล
                this.otpSkip = true;
            }
            else {
              if ((this.Contact.dpa_companytypeid == null || this.Contact.dpa_companytypeid == "") ) {
                $("#btnDOPAParent").removeClass("sr-only");
                ////$("#btnNDIDParent").addClass("sr-only");
                // $("#btnDOPAParent").removeClass("mr-3");
                //$("#btnByAgentBank").removeClass("ml-3");
              }
              //else if (this.Contact.dpa_companytypeid == null || this.Contact.dpa_companytypeid == "") {
              //  $("#btnDOPAParent").removeClass("sr-only");
                //$("#btnNDIDParent").removeClass("sr-only");
                //$("#btnByAgentBankParent").removeClass("sr-only");
              //}
              
              $("#divStart2").removeClass("sr-only");
            }
          }
          
        }

        if (State != "") {
          this.GotoState(State);
        }

        var TableDocs = $('#TableDocs');

        TableDocs.on('click', 'tbody tr td [role=view]', function () {
          thisTs.ViewDoc($(this).attr('url'), $(this).attr('filename'));
        });

        TableDocs.on('click', 'tbody tr td [role=delete]', function () {
          thisTs.DeleteDoc($(this).attr('filename'), $(this).attr('annotationid'));
        });

        this.AcceptExtension = environment.AcceptUploadFileExtension;
        this.MaxTotalSizeMB = await this.MasterService.GetMaxUploadFileSize();

        if (this.otpSkip == true){
          await this.ShowConsentForm();
        }
      }
      else {
        this.Util.ShowWaiting(false)
        this.Util.WarningDialog("กรุณาเข้าสู่ระบบ");
        $("#btnWarningOK").off("click");
        $("#btnWarningOK").click(function () {
          thisTs.router.navigate(["/mainmenu/login"]);
        });
      }
    }
    catch (e) {
      this.Util.ShowWaiting(false)
      console.log(e);
      this.Util.ErrorDialog("เกิดข้อผิดพลาด กรูณาติดต่อเจ้าหน้าที่")
    }
  }

  async StartProcess(DOPA: any = false) {
    this.Util.ShowWaiting(true);
    if (this.Contact.dpa_companytypeid != null && this.Contact.dpa_companytypeid != "") {
      $("#divStart").addClass("sr-only");
      if (this.Ticket.dpa_approvalstatuscode == '03') {
        $("#PhoneNo").html(this.Contact.dpa_authorizedperson_telephone);
        $("#divOTP").removeClass("sr-only");
      }
      else {
        await this.ShowDetails();
      }
    }
    else {
      if (DOPA) {
        if ($("#FirstNameDOPA").val() == "" || $("#LastNameDOPA").val() == "" || $("#IDNoDOPA").val() == "" || $("#LaserNoDOPA").val() == "" || $("#BirthDateDOPA").val() == "") {
          this.Util.WarningDialog("กรุณากรอกข้อมูลบังคับ (*) ให้ครบถ้วน");
          this.Util.ShowWaiting(false);
          return;
        }

        // let reqDopa:any = {
        //   request_number: "000001",
        //   service_code: "0001", 
        //   pid: $("#IDNoDOPA").val(),
        //   firstname: $("#FirstNameDOPA").val(),
        //   lastname: $("#LastNameDOPA").val(),
        //   birthday: $("#BirthDateDOPA").val(),
        //   laser: $("#LaserNoDOPA").val()
        // }

        // let resDopa: any = await this.Api.checkCard(reqDopa)

        // if(resDopa != null && resDopa.code == 0){
        //   let ParamObj = {
        //     dpa_dopaflag: true,
        //     // dpa_dopaagingdate: this.AddDays(new Date(), 180).toISOString().replace("Z", "").replace("z", "")
        //     dpa_dopaagingdate: new Date().toISOString()
        //   };
        //   let Res = await this.Api.put("crmservice", "contact-dopaflag-aging/" + this.Contact.contactid, ParamObj);
        //   this.Contact = await (this.Api.get("crmservice", "contact", "contactid=" + this.Profile.customerid));
        //   this.Contact = this.Contact[0]
        this.SubmitOTP(true);
        // }
        // else{
        //   if(resDopa.desc != null && resDopa.desc != ""){
        //     this.Util.WarningDialog(resDopa.desc)
        //   }
        //   else if(resDopa.errors != null){
        //     let msg: string = this.GetErrorMsgCheckCard(resDopa.errors)
        //     this.Util.WarningDialog(msg)
        //   }
        //   else{
        //     this.Util.WarningDialog("ข้อมูลไม่ถูกต้อง กรูณาตรวจสอบ")
        //   }
        // }
      }
      else {
        if (this.Ticket.dpa_approvalstatuscode == '03') {
          await this.SubmitOTP();
        }
        else {
          await this.ShowDetails();
        }
      }
      $("#divStart2").addClass("sr-only");
    }
    this.Util.ShowWaiting(false);
  }

  async DOPA() {
    $("#divStart2").addClass("sr-only");
    $("#divDOPA").removeClass("sr-only");
  }

  async OpenNDID() { 
    location.href = "webpage.html";
  }

  AddDays(date: any, days: any) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  async InvestigateAndAppealStatus() {
    if (this.drosWeb != "") {
      window.open(this.drosWeb, "_blank");
    }
    else{
      this.Util.WarningDialog("ไม่สามารถดำเนินการยื่นอุธรณ์ได้");
    }


    /* this.Util.ConfirmDialog("คุณต้องการ" + $("#lblInvestigate").html() + "ใช่หรือไม่");
     $("#btnMainConfirm").off('click');
     let thisTs = this;
     let Action: any;
     $("#btnMainConfirm").click(async function () {
       try {
         if (thisTs.InvestigateFlag) {
           thisTs.Contact.dpa_investigateflag = true;
           thisTs.Contact.dpa_investigatedate = new Date().toISOString();
           Action = 1;
         }
         else {
           thisTs.Contact.dpa_appealflag = true;
           thisTs.Contact.dpa_appealdate = new Date().toISOString();
           Action = 2;
         }
         let Res: any = await thisTs.Api.post("crmservice", "contact", thisTs.Contact);
         if (JSON.stringify(Res).includes("SUCCESS")) {
           $("#btnInvestigate").attr("disabled", "disabled");
           window.open("../investigate?a=" + Action, "_blank");
         }
         else {
           thisTs.Util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ")
         }
       }
       catch (e) {
         thisTs.Util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ")
       }
     });
     */
  }

  async ShowDetails() {
    $("#TicketNo").val(this.Ticket.dpa_name);
    if (this.Ticket.dpa_personaltypeid == null) {
      $("#CompanyType").val(this.Ticket.dpa_companytypeidname);
    }
    else {
      $("#CompanyType").val(this.Ticket.dpa_personaltypeidname);
    }
    $("#CompanyName").val(this.Ticket.dpa_contactidname);
    $("#RegistrationID").val(this.Ticket.dpa_registrationid);
    if (this.Contact.dpa_companytypeid != null && this.Contact.dpa_companytypeid != "") { 
      let firstname = ""
      let lastname = "" 
                  let name: string = this.Ticket.dpa_contactidname.split(" ");
                  if (name.length > 0) {
                    if (name.length == 1) {
                      firstname = name[0]
                    }
                    else if (name.length == 2) {
                      firstname = name[0]
                      lastname = name[1]
                    }
                    else {
                      for (let i = 0; i < name.length - 1; i++) {
                        firstname += " " + name[i]
                      }
                      firstname = firstname.trim()
                      lastname = name[name.length - 1]
                    }
                  } 
      $("#FirstName").val(firstname);
      $("#LastName").val(lastname);
      $("#CitizenID").val(this.Ticket.dpa_authorizedperson_idcard);
    }
    else { 
      let firstname = ""
      let lastname = "" 
                  let name: string = this.Ticket.dpa_contactidname.split(" ");
                  if (name.length > 0) {
                    if (name.length == 1) {
                      firstname = name[0]
                    }
                    else if (name.length == 2) {
                      firstname = name[0]
                      lastname = name[1]
                    }
                    else {
                      for (let i = 0; i < name.length - 1; i++) {
                        firstname += " " + name[i]
                      }
                      firstname = firstname.trim()
                      lastname = name[name.length - 1]
                    }
                  } 
      $("#FirstName").val(firstname);
      $("#LastName").val(lastname);
      $("#CitizenID").val(this.Ticket.dpa_idcard);
    }
    let v: any = this.translate.get("Send")
    let onlydate = 'รองรับเฉพาะไฟล์ประเภท ' +  this.AcceptExtension + ' ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB" ;
    $("#onlydata").html(onlydate);
    $("#Remark").val(this.Ticket.dpa_remark);
    $("#btnSendData").html(v.value);
    v = this.translate.get("Upload documents")
    switch (this.Ticket.dpa_approvalstatuscode) {
      case '01': $("#Status").val("In Progress"); break;
      case '02': $("#Status").val("Wait"); break;
      case '03': $("#Status").val("Approved"); break;
      case '05': $("#Status").val("Rejected"); $("#btnSendData").html(v.value); break;
      case '06': $("#Status").val("Rejected (Edit Docs)"); break;
      default: break;
    }

    await this.CreateDocumentList();
    this.TotalFileSize = 0;
    this.Ticket.attachfilelist.forEach((a: any) => {
      var Decoded = atob(a.documentbody);
      a.filesize = Decoded.length;
      this.TotalFileSize += a.filesize;
      a.url = "data:" + a.mimetype + ";base64," + a.documentbody;
    });
    this.FileList = this.Ticket.attachfilelist;
    await this.CreateTableFile();

    let thisTs = this;
    $('.docCheck').on("change", function (e: any) {
      thisTs.SelectDocument(e.target);
    });
    $("#divDetails").removeClass("sr-only");
  }

  async CreateDocumentList() {
    if (this.Ticket.dpa_personaltypeid == null) {
      if (this.CompanyType == null) {
        this.CompanyType = await this.Api.get("master", "companyType");
      }
      this.DocGroupList = this.CompanyType.filter((a: any) => a.dpa_companytypeid == this.Ticket.dpa_companytypeid)[0].dpa_documentgrouplist;
    }
    else {
      if (this.PersonalType == null)
        this.PersonalType = await this.Api.get("master", "personalType");
      this.DocGroupList = this.PersonalType.filter((a: any) => a.dpa_personaltypeid == this.Ticket.dpa_personaltypeid)[0].dpa_documentgrouplist;
    }

    this.DocumentList = [];
    if (this.Ticket.dpa_documentchecklist != null && this.Ticket.dpa_documentchecklist != "") {
      let Selected = this.Ticket.dpa_documentchecklist.split("|");
      for (var i = 0; i < Selected.length; i++) {
        this.DocumentList.push({
          "dpa_documentid": Selected[i]
        });
      }
    }
    $("#divDocList").empty();
    let DivContent = '<br />';
    let SeqNo = 1;
    let Checked = "";
    // this.DocGroupList.forEach((DocGroup: any) => {
    //   DocGroup["dpa_documentlist"].forEach((Doc: any) => {
    //     Checked = this.DocumentList.length == 0 ? "" : this.Ticket.dpa_documentchecklist.includes(Doc.dpa_documentid) ? " checked" : "";
    //     DivContent += '<label class="checktable">';
    //     DivContent += ' <input type="checkbox" class="docCheck" value="' + Doc.dpa_documentid + '"' + Checked + '><span class="checkmark"></span>';
    //     DivContent += ' <label>' + SeqNo + '. ' + Doc.dpa_name + '</label>';
    //     DivContent += '</label>';
    //     SeqNo++;
    //   });
    // });
    this.DocGroupList.forEach((DocGroup: any) => {
      Checked = this.DocumentList.length == 0 ? "" : this.Ticket.dpa_documentchecklist.includes(DocGroup.dpa_documentgroupid) ? " checked" : "";
      DivContent += '<label class="checktable">';
      DivContent += ' <input type="checkbox" class="docCheck" value="' + DocGroup.dpa_documentgroupid + '"' + Checked + '><span class="checkmark"></span>';
      DivContent += ' <label>' + SeqNo + '. ' + DocGroup.dpa_name + '</label>';
      DivContent += '</label>';
      SeqNo++;
    });
    $("#divDocList").append(DivContent);
  }

  CreateTableFile() {
    let thisTs = this;
    var TableDocs = $('#TableDocs').DataTable({
      "paging": false,
      "bFilter": false,
      "info": false,
      "data": thisTs.FileList,
      "columns": [
        { "data": "filename", "class": "text-center" },
        { "data": "filename" },
        {
          "data": "filesize",
          "render": function (data: any, type: any, row: any) {
            if (row.filesize / 1024 / 1024 < 1) {
              return Math.floor(row.filesize / 1024) + ' KB';
            }
            else {
              return (Math.round(row.filesize / 1024 / 1024 * 100 + Number.EPSILON) / 100) + ' MB';
            }
          },
          "class": "text-right"
        },
        {
          "data": null,
          "render": function (data: any, type: any, row: any) {
            return '<i class="fa fa-eye editicon cursorpointer" role="view" url="' + row.url + '" filename="' + row.filename + '" title="View"></i>' +
              (thisTs.Editable ? '<i class="fa fa-times deleteicon cursorpointer" role="delete" filename="' + row.filename + '" annotationid="' + row.annotationid + '" title="Delete"></i>' : '');
          },
          "class": "col-btn-2 text-center"
        }
      ],
      "language": {
        "zeroRecords": "ยังไม่ได้อัปโหลดไฟล์"
      }
    });

    TableDocs.on('order.dt search.dt', function () {
      TableDocs.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell: any, i: any) {
        cell.innerHTML = i + 1;
      });
    }).destroy().draw();
  }

  SelectDocument(target: any) {
    if (target.checked) {
      if (this.DocumentList == null || this.DocumentList == undefined)
        this.DocumentList = [];
      this.DocumentList.push({
        "dpa_documentid": target.value,
      });
    }
    else {
      this.DocumentList = this.DocumentList.filter((a: any) => a.dpa_documentid != target.value);
    }
  }

  async ViewDoc(Url: any, FileName: any) {
    if (Url == "") {
      this.Util.ErrorDialog('ไม่พบไฟล์ที่เลือก');
      return;
    }
    window.open(this.Util.CreateBlobUrl(Url), "_blank");

    // $("#FileNameTitle").html(FileName);
    // $("#ViewDocFrame").attr("src", this.Util.CreateBlobUrl(Url));
    // $('#dlgFile').modal();

    // var link = document.createElement('a');
    // link.href = Url;
    // link.target = "_blank";
    // link.download = FileName;
    // link.click();
    // console.log("click!");
  }

  async DeleteDoc(FileName: any, AnnotationID: any) {
    let thisTs = this;
    this.Util.ConfirmDialog("คุณต้องการลบไฟล์เอกสารแนบใช่หรือไม่?");
    $("#btnMainConfirm").off('click');
    $("#btnMainConfirm").click(async function () {
      if (AnnotationID != null && AnnotationID != "" && AnnotationID != "null") {
        // await thisTs.Api.delete("crmservice", "delAnnotation/" + AnnotationID);
        let DelObj: any = {
          annotationid: AnnotationID
        };
        await thisTs.Api.post("crmservice", "delAnnotation2", DelObj);
      }
      thisTs.FileList.forEach((item: any, index: any) => {
        if (item["filename"] === FileName)
          thisTs.FileList.splice(index, 1);
      });
      thisTs.CreateTableFile();
    });
  }

  async FileSelect(File: any) {
    if (File.length == 0)
      return;
    var FileName = File[0]["name"];
    var FileExtension = FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length);

    if (!this.AcceptExtension.includes(FileExtension.toLowerCase())) {
      this.Util.ErrorDialog('รองรับเฉพาะไฟล์ ' + this.AcceptExtension);
      $('#fileAttach').val('');
      return;
    }

    var TotalFileSize: number = File[0]["size"];
    this.FileList.forEach((a: any) => {
      TotalFileSize += +a["filesize"];
    });
    if (TotalFileSize / 1024 / 1024 > this.MaxTotalSizeMB) {
      this.Util.ErrorDialog('ขนาดไฟล์รวมทั้งหมดต้องไม่เกิน ' + this.MaxTotalSizeMB + " MB");
      $('#fileAttach').val('');
      return;
    }
    if (this.FileList != null) {
      if (this.FileList.filter((a: any) => a.filename == File[0].name).length > 0) {
        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
        return;
      }
    }

    var FR = new FileReader();
    var FileContent: any;
    var MimeType: any;
    let thisTs = this;
    FR.onload = (e) => {
      var t: any = e.target;
      FileContent = t.result;
      MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
      var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);

      if (thisTs.FileList == null || thisTs.FileList == undefined)
        thisTs.FileList = [];
      thisTs.FileList.push({
        "annotationid": null,
        "filename": File[0].name,
        "documentbody": FileContent2,
        "mimetype": MimeType,
        "filesize": File[0]["size"],
        "url": FileContent
      });
      $('#fileAttach').val('');
      // $('#txtFileName').val('');
      thisTs.CreateTableFile();
    };
    FR.readAsDataURL(File[0]);

    // $('#txtFileName').val(File[0]["name"]);
  }

  async UploadFile() {
    var FileInput = $('#fileAttach')[0]["files"];
    if (FileInput.length == 0) {
      this.Util.ErrorDialog('กรุณาเลือกไฟล์');
      return;
    }
    if (this.FileList != null) {
      if (this.FileList.filter((a: any) => a.filename == FileInput[0].name).length > 0) {
        this.Util.WarningDialog("ชื่อไฟล์ซ้ำกับไฟล์ที่อัปโหลดแล้ว");
        return;
      }
    }

    var File = new FileReader();
    var FileContent: any;
    var MimeType: any;
    let thisTs = this;
    File.onload = async (e) => {
      var t: any = e.target;
      FileContent = t.result;
      MimeType = FileContent.substring(FileContent.indexOf(":") + 1, FileContent.indexOf(";"));
      var FileContent2 = FileContent.substring(FileContent.indexOf(",") + 1, FileContent.length);

      if (thisTs.FileList == null || thisTs.FileList == undefined)
        thisTs.FileList = [];
      thisTs.FileList.push({
        "annotationid": null,
        "filename": FileInput[0].name,
        "documentbody": FileContent2,
        "mimetype": MimeType,
        "filesize": FileInput[0]["size"],
        "url": FileContent
      });
      this.TotalFileSize += +FileInput[0]["size"];
      $('#fileAttach').val('');
      $('#txtFileName').val('');
      if (thisTs.Ticket.dpa_approvalstatuscode == '02') {
        thisTs.Ticket.attachfilelist = thisTs.FileList;

        thisTs.Ticket["dpa_approvalstatusid"] = thisTs.GetStatusGuidByCode(thisTs.Ticket.dpa_approvalstatuscode)

        await thisTs.Api.post("crmservice", "approvalticket", thisTs.Ticket);
        let T: any = await thisTs.Api.get("crmservice", "searchapprovalticket", "ticketno=" + thisTs.Ticket.dpa_name);
        thisTs.Ticket = T[0];
        thisTs.Ticket.attachfilelist.forEach((a: any) => {
          var Decoded = atob(a.documentbody);
          a.filesize = Decoded.length;
          a.url = "data:" + a.mimetype + ";base64," + a.documentbody;
        });
        thisTs.FileList = thisTs.Ticket.attachfilelist;
      }
      thisTs.CreateTableFile();
    };
    File.readAsDataURL(FileInput[0]);
  }

  async SendData() {

    if (this.Ticket.dpa_statdpa_approvalstatuscodeus == '05' && !this.Editable) {
      this.Util.ShowWaiting(true);
      $("#divDocList").removeAttr("disabled");
      $("#divUpload").removeClass("sr-only");
      $("#btnSendData").html("ยืนยันส่งข้อมูล");
      this.Editable = true;
      this.Ticket.dpa_documentchecklist = "";
      this.Ticket.attachfilelist = [];
      this.FileList = [];
      await this.CreateDocumentList();
      await this.CreateTableFile();
      let thisTs = this;
      $('.docCheck').on("change", function (e: any) {
        thisTs.SelectDocument(e.target);
      });
      this.Util.ShowWaiting(false);
      return;
    }

    if (this.FileList.length == 0) {
      this.Util.WarningDialog("กรุณาอัปโหลดไฟล์เอกสาร");
      return;
    }

    if (this.DocumentList.length == 0) {
      this.Util.WarningDialog("กรุณาเลือกประเภทเอกสาร");
      return;
    }

    let IsValid: any = await this.ValidateSelectedDocument(this.DocumentList, this.DocGroupList);
    if (!IsValid)
      return;

    this.Util.ShowWaiting(true);
    if (this.Ticket.dpa_approvalstatuscode == '05') {
      this.Ticket.dpa_approvalstatuscode = '01';
      this.Ticket.dpa_approvalticketid = null;
      this.Ticket.dpa_name = null;
      this.Ticket.dpa_originalsource = 1;
      this.Ticket.dpa_remark = "";
      this.Ticket.dpa_submitdate = new Date();
    }
    else {
      this.Ticket.dpa_submitdate = this.Ticket.dpa_submitdate.substring(0, 10);
      this.Ticket.dpa_approvalstatuscode = '01';
    }
    var DocList = "";
    this.DocumentList.forEach((a: any) => {
      DocList += (DocList == "" ? "" : "|") + a.dpa_documentid;
    });
    this.Ticket.attachfilelist = this.FileList;
    this.Ticket.dpa_documentchecklist = DocList;
    this.TotalFileSize = 0;
    this.Ticket.attachfilelist.forEach((a: any) => {
      var Decoded = atob(a.documentbody);
      a.filesize = Decoded.length;
      this.TotalFileSize += a.filesize;
      a.url = "";
    });
    this.Ticket.dpa_attachsizing = this.TotalFileSize;
    try {


      this.Ticket["dpa_approvalstatusid"] = this.GetStatusGuidByCode(this.Ticket.dpa_approvalstatuscode)

      let Res: any = await this.Api.post("crmservice", "approvalticket", this.Ticket);

      this.Ticket = await (this.Api.get("crmservice", "searchApprovalTicket", "contactid=" + this.Profile.customerid));

      if (this.Ticket.length > 1) {
        let LastDate: Date;
        let TmpTicket: any;
        this.Ticket.forEach((a: any) => {
          if (LastDate == null || LastDate == undefined) {
            LastDate = new Date(a.dpa_submitdate);
            TmpTicket = a;
          }
          else {
            if (LastDate < new Date(a.dpa_submitdate)) {
              LastDate = new Date(a.dpa_submitdate);
              TmpTicket = a;
            }
          }
        });
        this.Ticket = TmpTicket;
      }
      else {
        this.Ticket = this.Ticket[0];
      }

      if (this.Ticket.dpa_approvalstatuscode == "01") {
        $("#TicketNo").val(this.Ticket.dpa_name);
        this.Editable = false;
        this.ShowDetails();
        $("#btnSendData").addClass("sr-only");
        this.Util.SuccessDialog("ส่งข้อมูลสำเร็จ");
      }
      else {
        this.Util.SuccessDialog("อัปโหลดเอกสารยืนยันตัวตนสำเร็จ กรุณาตรวจสอบการอนุมัติเอกสารได้ที่อีเมลของท่าน");
      }

      let thisTs = this
      $("#btnSuccessOK").off('click');
      $("#btnSuccessOK").click(async function () {
        //$("#divStart").removeClass("sr-only");
        //$("#divDetails").addClass("sr-only");
        //thisTs.router.navigate(["/mainmenu/index"]);
      });
    }
    catch (err) {
      console.log(err);
      this.Util.WarningDialog("ไม่สามารถบันทึกข้อมูลได้");
    }

    this.Util.ShowWaiting(false);
  }

  BackToHome() {
    this.router.navigate(["/mainmenu/index"]);
    // $("#divStart").removeClass("sr-only");
    // if (!$("#divDetails").hasClass("sr-only")) {
    //   $("#divDetails").addClass("sr-only")
    // }
    // if (!$("#divOTP").hasClass("sr-only")) {
    //   $("#divOTP").addClass("sr-only")
    // }
    // if (!$("#divCondition").hasClass("sr-only")) {
    //   $("#divCondition").addClass("sr-only")
    // }
    // if (!$("#divBankList").hasClass("sr-only")) {
    //   $("#divBankList").addClass("sr-only")
    // }
    // if (!$("#divSummary").hasClass("sr-only")) {
    //   $("#divSummary").addClass("sr-only")
    // }
  }

  async ValidateSelectedDocument(Selected: any, DocGroup: any) {
    if (Selected == null || Selected == undefined || Selected.length == 0)
      return false;
    var ItemFound: boolean;
    var IsValid = true;
    var Msg = "", Msg2 = "";
    DocGroup.forEach((DocList: any) => {
      ItemFound = false;
      Msg2 = "";
      // DocList.dpa_documentlist.forEach((Doc: any) => {
      //   Selected.forEach((a: any) => {
      //     if (a.dpa_documentid == Doc.dpa_documentid) {
      //       ItemFound = true;
      //     }
      //   });
      //   Msg2 += (Msg2 == "" ? "" : " หรือ ") + Doc.dpa_name;
      // });
      Selected.forEach((a: any) => {
        if (a.dpa_documentid == DocList.dpa_documentgroupid) {
          ItemFound = true;
        }
      });
      Msg2 = DocList.dpa_name;

      if (!ItemFound) {
        IsValid = false;
        Msg += (Msg == "" ? "" : " และ ") + Msg2;
      }
    });
    if (!IsValid)
      this.Util.WarningDialog("กรุณาเลือก" + Msg);
    return IsValid;
  }

  async SubmitOTP(ToBankList: any = false) {
    /*let State = await this.GetState();
    if ($("#OTP").val() == "") {
      if (State == "") {
        this.Util.WarningDialog("กรุณาระบุรหัส OTP");
        $("#btnWarningOK").off("click");
        $("#btnWarningOK").click(function () {
          setTimeout(() => {
            $("#OTP").focus();
          }, 200);
        });
        return;
      }
    } 

    if (ToBankList == false && State == "") {
      let ParamObj: any = {
        OTP: $("#OTP").val(),
        RefCode: this.OTPRefCode,
        MobileNo: this.Contact.telephone1
      };
      let Res: any = await this.Api.postCustomApi("Crm", "VerifyOTP", ParamObj);
      if (!this.Util.isSuccessResponse(Res)) {
        this.Util.WarningDialog("เกิดข้อผิดพลาดระหว่างตรวจสอบ OTP กรุณาติดต่อผู้ดูแลระบบ");
        return;
      } 
      if (Res.IsValid == false) {
        this.Util.WarningDialog("รหัส OTP ไม่ถูกต้อง");
        return;
      }
    }*/
  
    localStorage.setItem("oneOTP", JSON.stringify(this.Contact))
    $("#divOTP").addClass("sr-only");
    this.SetState("skipotp");
    if (this.Contact.dpa_companytypeid != null && this.Contact.dpa_companytypeid != "" ||
      (this.Contact.dpa_dopaflag != null && this.Contact.dpa_dopaflag == true && this.Contact.dpa_dopaagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)) ||
      (this.Contact.dpa_ndidflag != null && this.Contact.dpa_ndidflag == true && this.Contact.dpa_ndidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)) ||
      (this.Contact.dpa_thaidflag != null && this.Contact.dpa_thaidflag == true && this.Contact.dpa_thaidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10))) 
      { //นิติบุคคล
      await this.ShowConsentForm();
    }
    else {
      if ((this.Contact.dpa_companytypeid == null || this.Contact.dpa_companytypeid == "") ) {
        $("#btnDOPAParent").removeClass("sr-only");
        ////$("#btnNDIDParent").addClass("sr-only");
        // $("#btnDOPAParent").removeClass("mr-3");
        //$("#btnByAgentBank").removeClass("ml-3");
      }
      //else if (this.Contact.dpa_companytypeid == null || this.Contact.dpa_companytypeid == "") {
      //  $("#btnDOPAParent").removeClass("sr-only");
        //$("#btnNDIDParent").removeClass("sr-only");
        //$("#btnByAgentBankParent").removeClass("sr-only");
      //}
      
      $("#divStart2").removeClass("sr-only");
    }
  }

  async ShowConsentForm() {
    $("#divCondition").removeClass("sr-only");
    $("#divDOPA").addClass("sr-only");
    //$("#btnNDIDParent").addClass("sr-only");

    //boy comment
    //if (this.Contact.dpa_allowemail || this.Contact.dpa_allowsms) {
    //  $("#ReceiveNews").attr("checked", "checked");
    //}
    //else {
    //  $("#ReceiveNews").removeAttr("checked");
    //}

    let thisTs = this;
    $("#Accept").off('click');
    $("#Accept").click(async function () {
      if (!$("#Accepted")[0].checked) {
        thisTs.Util.WarningDialog("กรุณายอมรับเงื่อนไข");
        return;
      }
      thisTs.Util.ShowWaiting(true);
      // let BankList: any = await thisTs.Api.get("master", "bank");
      // let Bank: any;
      // let EffectiveDate: any = "-";
      // let CardList: any = "";
      // $("#divBankCard").empty();
      // if (thisTs.ContactDros.CRM07 == null || thisTs.ContactDros.CRM07 == undefined) {
      //   thisTs.Util.ShowWaiting(false);
      //   thisTs.Util.WarningDialog("ไม่พบข้อมูล");
      //   return;
      // }
      // thisTs.ContactDros.CRM07.forEach(async (a: any) => {
      //   Bank = BankList.filter((b: any) => b.dpa_bankcode == a.BankCode)[0];
      //   if (Bank.dpa_effectivedate != null && Bank.dpa_effectivedate != "") {
      //     EffectiveDate = new Date(Bank.dpa_effectivedate.substring(0, 10));
      //     EffectiveDate = thisTs.Util.ConvertToBE(EffectiveDate.getDate() + "/" + (EffectiveDate.getMonth() + 1) + "/" + EffectiveDate.getFullYear());
      //   }

      //   CardList = '<div class="row mt-3">' +
      //     '  <div class="col-12 centered-content">' +
      //     '    <button class="btn bank-card" id="' + a.BankCode + '">' +
      //     '      <i class="fas fa-chevron-right bank-card-arrow"></i>' +
      //     '      <img class="bank-card-icon" src="../../assets/images/bank.png">' +
      //     '      <div class="text-left bank-card-title">' +
      //     '        <span>' + Bank.dpa_name + '</span>' +
      //     '      </div>' +
      //     '      <div class="text-left bank-card-info1">' +
      //     '        <span>' +
      //     '          <img src="../../assets/images/warning.png">' +
      //     '          Effective: ' + EffectiveDate +
      //     '        </span>' +
      //     '      </div>' +
      //     '      <div class="text-left bank-card-info2">' +
      //     '        <span>เบอร์โทรติดต่อ: ' + (Bank.dpa_telephoneno == null || Bank.dpa_telephoneno == "" ? "-" : Bank.dpa_telephoneno) + '</span>' +
      //     '      </div>' +
      //     '    </button>' +
      //     '  </div>' +
      //     '</div>';
      //   $("#divBankCard").append(CardList);
      //   $("#" + a.BankCode).off("click");
      //   $("#" + a.BankCode).click(async function () {
      //     thisTs.ViewSummary(a.BankCode);
      //   });

      // });

      // boy comment out
      thisTs.Contact.dpa_allowemail = true;//$("#ReceiveNews")[0].checked;
      thisTs.Contact.dpa_allowsms = thisTs.Contact.dpa_allowemail;
      await thisTs.Api.post("crmservice", "contact", thisTs.Contact);

      //localStorage.setItem("oneOTP", JSON.stringify(thisTs.Contact))
      $("#divCondition").addClass("sr-only");

      
      let v = localStorage.getItem("verifyIdentity");
      if (v == "true"){
        // $("#divBankList").removeClass("sr-only");
        await thisTs.ShowBankList();
        
        //$("#divStart2").removeClass("sr-only");
      }
      else if (thisTs.Contact.dpa_thaidflag != null && thisTs.Contact.dpa_thaidflag == true &&
        thisTs.Contact.dpa_thaidagingdate != null && thisTs.Contact.dpa_thaidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)){

          await thisTs.ShowBankList();
        
      }
      else if (thisTs.Contact.dpa_ndidflag != null && thisTs.Contact.dpa_ndidflag == true &&
        thisTs.Contact.dpa_ndidagingdate != null &&  thisTs.Contact.dpa_ndidagingdate.substring(0, 10) >= new Date().toISOString().substring(0, 10)){

          await thisTs.ShowBankList();
        
      }
      else {
        // $("#divBankList").removeClass("sr-only");
        //await thisTs.ShowBankList();
        
        $("#divStart2").removeClass("sr-only");
      }
      thisTs.Util.ShowWaiting(false);
    });

    $("#Reject").off('click');
    $("#Reject").click(async function () {
      $("#divCondition").addClass("sr-only");
      $("#divOTP").removeClass("sr-only");
    });

    this.SetState("consent");
  }

  async ShowBankList() {
    let BankList: any = await this.Api.get("master", "bank");
    let Bank: any;
    let EffectiveDate: any = "-";
    let CardList: any = "";
    let thisTs = this;
    $("#divBankCard").empty();
    if (this.ContactDros.CRM07 == null || this.ContactDros.CRM07 == undefined) {
      this.Util.ShowWaiting(false);
      this.Util.WarningDialog("ไม่พบข้อมูล");
      return;
    }

    let crm07: any = []
    this.ContactDros.CRM07.forEach((c: any) => {
      let found: any = crm07.filter((t: any) => {
        return c.BankCode == t.BankCode
      })
      if (found == null || found.length == 0) {
        crm07.push(c)
      }
    })

    crm07.forEach(async (a: any) => {
      Bank = BankList.filter((b: any) => b.dpa_bankcode == a.BankCode)[0];
      if (Bank.dpa_effectivedate != null && Bank.dpa_effectivedate != "") {
        EffectiveDate = new Date(Bank.dpa_effectivedate.substring(0, 10));
        EffectiveDate = this.Util.ConvertToBE(EffectiveDate.getDate() + "/" + (EffectiveDate.getMonth() + 1) + "/" + EffectiveDate.getFullYear());
      }
      let v: any = this.translate.get("Phone no.")
      let ve: any = this.translate.get("Effective Date")
      CardList = '<div class="row mt-3">' +
        '  <div class="col-12 centered-content">' +
        '    <button class="btn bank-card view-summary-btn" id="' + a.BankCode + '">' +
        '      <i class="fas fa-chevron-right bank-card-arrow"></i>' +
        '      <img class="bank-card-icon" src="../../assets/images/bank.png">' +
        '      <div class="text-left bank-card-title">' +
        '        <span>' + Bank.dpa_name + '</span>' +
        '      </div>' +
        '      <div class="text-left bank-card-info1">' +
        '        <span>' +
        '          <img src="../../assets/images/warning.png">' +
        '          ' + ve.value + ': ' + EffectiveDate +
        '        </span>' +
        '      </div>' +
        '      <div class="text-left bank-card-info2">' +
        '        <span>' + v.value + ': ' + (Bank.dpa_telephoneno == null || Bank.dpa_telephoneno == "" ? "-" : Bank.dpa_telephoneno) + '</span>' +
        '      </div>' +
        '    </button>' +
        '  </div>' +
        '</div>';
      $("#divBankCard").append(CardList);
      $("#" + a.BankCode).off("click");
      // $("#" + a.BankCode).click(async function () {
      //   thisTs.ViewSummary(a.BankCode);
      // });

      $(".view-summary-btn").click(async function () {
        thisTs.ViewSummary(this.id);
      });
    });
    //$("#divBankList").removeClass("sr-only");
    this.SetState("banklist");
    $(".view-summary-btn").click();
  }

  async ViewSummary(BankCode: any) {
    if (this.ContactDros.CRM06 == null) {
      this.Util.WarningDialog("ไม่มีข้อมูลรายละเอียดเงินฝากของท่าน");
      return;
    }
    let NoOfAcc: number =   parseInt(this.ContactDros.CRM06.NumberOfDepositAccounts || 0)  ;

    $("#NoOfAcc").html(NoOfAcc);

    let NetReimbursible = parseFloat(this.ContactDros.CRM06.NetReimbursible)
    let TaxAmount = parseFloat(this.ContactDros.CRM06.TaxAmount)

    $("#Amount").html(  this.Util.numberWithCommas( this.FormatNumber((isNaN(NetReimbursible) ? 0 : NetReimbursible) + (isNaN(TaxAmount) ? 0 : TaxAmount))));
    $("#TaxAmount").html(this.Util.numberWithCommas(this.FormatNumber(isNaN(TaxAmount) ? 0 : TaxAmount)));
    $("#NetAmount").html(this.Util.numberWithCommas(this.FormatNumber(isNaN(NetReimbursible) ? 0 : NetReimbursible)));

    $("#PaymentStatus1_1").html("");
    $("#PaymentStatus2_1").html("");
    $("#PaymentStatus1_2").html("");
    $("#PaymentStatus2_2").html("");
    $("#PaymentStatus1_3").html("");
    $("#PaymentStatus2_3").html("");
    $("#PaymentStatus1_4").html("");
    $("#PaymentStatus2_4").html("");
    $("#PaymentStatus1_5").html("");
    $("#PaymentStatus2_5").html("");
    $("#divPaymentStatus").addClass("sr-only");
    $("#Status1").html("");
    $("#Status2").html("");
    // if (this.ContactDros.CRM02 == null || this.ContactDros.CRM02.length == 0) {
    //   return;
    // }
    // let CRM02: any = this.ContactDros.CRM02.filter((a: any) => a.RequestedNo.substring(0, 1) == "I");
    // if (CRM02.length == 0) {
    //   return;
    // }
    let LastDate: Date = null;
    let Rec03: any = {}, Rec04: any = {}, Rec05: any = {}, Rec06: any = {};
    if (this.ContactDros.CRM04 != null || this.ContactDros.CRM04.length != 0) {
      this.ContactDros.CRM04.forEach((a: any) => {
        if (LastDate == null) {
          //Rec04 = a;
          LastDate = new Date(a.ModifyDate.substring(0, 19));
        }
        else if (LastDate < new Date(a.ModifyDate.substring(0, 19))) {
          //Rec04 = a;
          LastDate = new Date(a.ModifyDate.substring(0, 19));
        }
      });
      Rec04 = this.ContactDros.CRM04;
      Rec05 = this.ContactDros.CRM05;
      Rec06 = this.ContactDros.CRM06;

      let res04_type01 = Rec04.filter((a: any) => a.RequestType == "จ่ายคืนผู้ฝาก")
      let res04_type02 = Rec04.filter((a: any) => a.RequestType == "ยื่นคำขอรับเงิน")
      let res04_type03 = Rec04.filter((a: any) => a.RequestType == "ยื่นคำขอรับเงิน (กรณีไม่พบข้อมูล)")
      let res04_type04 = Rec04.filter((a: any) => a.RequestType == "ยื่นขอตรวจสอบ")
      let res04_type05 = Rec04.filter((a: any) => a.RequestType == "ยื่นอุทธรณ์")
      
      if (res04_type01.length > 0){        
        let StatusText1: string = res04_type01[0].RequestType || "";
        if (res04_type01[0].ChequeNo != null && res04_type01[0].ChequeNo != "") {
          StatusText1 += " เลขที่เช็ค " + res04_type01[0].ChequeNo;
          $("#divPaymentStatus").removeClass("sr-only");
        }
        if (res04_type01[0].ChequeIssueDate != null && res04_type01[0].ChequeIssueDate != "") {
          StatusText1 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type01[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
          $("#divPaymentStatus").removeClass("sr-only");

          
        }

        StatusText1 += " จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(Rec06.Reimbursable) ? 0 : Rec06.Reimbursable)) + " บาท";

        $("#PaymentStatus1_1").html(StatusText1);
        
        if (res04_type01[0].TransferedDate != null && res04_type01[0].TransferedDate != "") {
          let v: any = this.translate.get("Date of payment")
          $("#PaymentStatus2_1").html(v.value + " " + this.Util.transformDate((new Date(res04_type01[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
          $("#divPaymentStatus").removeClass("sr-only");
        }
      }else{
        $("#PaymentStatus1").addClass("sr-only");
      }

      if (res04_type02.length > 0){        
        let StatusText2: string = res04_type02[0].RequestType || "";
        if (res04_type02[0].ChequeNo != null && res04_type02[0].ChequeNo != "") {
          StatusText2 += " เลขที่เช็ค " + res04_type02.ChequeNo;
          $("#divPaymentStatus").removeClass("sr-only");
        }
        if (res04_type02[0].ChequeIssueDate != null && res04_type02[0].ChequeIssueDate != "") {
          StatusText2 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type02[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
          $("#divPaymentStatus").removeClass("sr-only");

        }
          
        StatusText2 += " จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(Rec06.Reimbursable) ? 0 : Rec06.Reimbursable)) + " บาท";
        
          $("#PaymentStatus1_2").html(StatusText2);
        
        if (res04_type02[0].TransferedDate != null && res04_type02[0].TransferedDate != "") {
          let v: any = this.translate.get("Date of payment")
          $("#PaymentStatus2_2").html(v.value + " " + this.Util.transformDate((new Date(res04_type02[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
          $("#divPaymentStatus").removeClass("sr-only");
        }
      }else{
        $("#PaymentStatus2").addClass("sr-only");
      }

      if (res04_type03.length > 0){
        let StatusText3: string = res04_type03[0].RequestType || "";
        if (res04_type03[0].ChequeNo != null && res04_type03[0].ChequeNo != "") {
          StatusText3 += " เลขที่เช็ค " + res04_type03[0].ChequeNo;
          $("#divPaymentStatus").removeClass("sr-only");
        }
        if (res04_type03[0].ChequeIssueDate != null && res04_type03[0].ChequeIssueDate != "") {
          StatusText3 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type03[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
          $("#divPaymentStatus").removeClass("sr-only");
          
        }
        
        StatusText3 += " จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(Rec06.Reimbursable) ? 0 : Rec06.Reimbursable)) + " บาท";

          $("#PaymentStatus1_3").html(StatusText3);
        
        if (res04_type03[0].TransferedDate != null && res04_type03[0].TransferedDate != "") {
          let v: any = this.translate.get("Date of payment")
          $("#PaymentStatus2_3").html(v.value + " " + this.Util.transformDate((new Date(res04_type03[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
          $("#divPaymentStatus").removeClass("sr-only");
        }
      }else{
        $("#PaymentStatus3").addClass("sr-only");
      }

      if (res04_type04.length > 0){
        let StatusText4: string = res04_type04[0].RequestType || "";
        if (res04_type04[0].ChequeNo != null && res04_type04[0].ChequeNo != "") {
          StatusText4 += " เลขที่เช็ค " + res04_type04.ChequeNo;
          $("#divPaymentStatus").removeClass("sr-only");
        }
        if (res04_type04[0].ChequeIssueDate != null && res04_type04[0].ChequeIssueDate != "") {
          StatusText4 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type04[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
          $("#divPaymentStatus").removeClass("sr-only");
          
        $("#PaymentStatus4").attr("style","padding-bottom: 15px;");
        }
        
        let res05Type04 = Rec05.filter((a: any) => a.RequestTypeCode == 4);
        if (res05Type04.length > 0){
          if (res05Type04[0].Result == "จ่ายเพิ่ม"){
            StatusText4 += " จ่ายคืนเงินคุ้มครองเพิ่มเติม จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type04[0].FinallyReimbursible) ? 0 : res05Type04[0].FinallyReimbursible)) + " บาท";
          }
          if (res05Type04[0].Result == "เท่าเดิม"){
            StatusText4 += " จ่ายคืนเงินคุ้มครองเท่าเดิม";
          }
          if (res05Type04[0].Result == "เรียกคืน"){
            StatusText4 += " เรียกคืนเงินฝาก จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type04[0].FinallyReimbursible) ? 0 : res05Type04[0].FinallyReimbursible)) + " บาท";
          }
          
          $("#PaymentStatus1_4").html(StatusText4);
          //$("#PaymentStatus2_4").addClass("sr-only");
          $("#PaymentStatus4 br").addClass("sr-only");
        }
        $("#PaymentStatus1_4").html(StatusText4);
        
        if (res04_type04[0].TransferedDate != null && res04_type04[0].TransferedDate != "") {
          let v: any = this.translate.get("Date of payment")
          $("#PaymentStatus2_4").html(v.value + " " + this.Util.transformDate((new Date(res04_type04[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
          $("#divPaymentStatus").removeClass("sr-only");
          
          $("#PaymentStatus4").attr("style","padding-bottom: 15px;");
        }

      }
      else{
        let res05Type04 = Rec05.filter((a: any) => a.RequestTypeCode == 4);
        let StatusText4: string = "ยื่นขอตรวจสอบ";
        if (res05Type04.length > 0){
          if (res05Type04[0].Result == "จ่ายเพิ่ม"){
            StatusText4 += " จ่ายคืนเงินคุ้มครองเพิ่มเติม จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type04[0].FinallyReimbursible) ? 0 : res05Type04[0].FinallyReimbursible)) + " บาท";
          }
          if (res05Type04[0].Result == "เท่าเดิม"){
            StatusText4 += " จ่ายคืนเงินคุ้มครองเท่าเดิม";
          }
          if (res05Type04[0].Result == "เรียกคืน"){
            StatusText4 += " เรียกคืนเงินฝาก จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type04[0].FinallyReimbursible) ? 0 : res05Type04[0].FinallyReimbursible)) + " บาท";
          }
          
          $("#PaymentStatus1_4").html(StatusText4);
          $("#PaymentStatus2_4").addClass("sr-only");
          $("#PaymentStatus4 br").addClass("sr-only");
        }
        else{
          $("#PaymentStatus4").addClass("sr-only");
        }

      }

      if (res04_type05.length > 0){
        let StatusText5: string = res04_type05[0].RequestType || "";
        if (res04_type05[0].ChequeNo != null && res04_type05[0].ChequeNo != "") {
          StatusText5 += " เลขที่เช็ค " + res04_type05.ChequeNo;
          $("#divPaymentStatus").removeClass("sr-only");
        }
        if (res04_type05[0].ChequeIssueDate != null && res04_type05[0].ChequeIssueDate != "") {
          StatusText5 += " วันที่ออก " + this.Util.transformDate((new Date(res04_type05[0].ChequeIssueDate)).toISOString().substring(0, 10), "short");
          $("#divPaymentStatus").removeClass("sr-only");
        }
        
        let res05Type05 = Rec05.filter((a: any) => a.RequestTypeCode == 5);
        if (res05Type05.length > 0){
          if (res05Type05[0].Result == "จ่ายเพิ่ม"){
            StatusText5 += " จ่ายคืนเงินคุ้มครองเพิ่มเติม จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type05[0].FinallyReimbursible) ? 0 : res05Type05[0].FinallyReimbursible)) + " บาท";
          }
          if (res05Type05[0].Result == "เท่าเดิม"){
            StatusText5 += " จ่ายคืนเงินคุ้มครองเท่าเดิม";
          }
          if (res05Type05[0].Result == "เรียกคืน"){
            StatusText5 += " เรียกคืนเงินฝาก จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type05[0].FinallyReimbursible) ? 0 : res05Type05[0].FinallyReimbursible)) + " บาท";
          }
          
          $("#PaymentStatus1_5").html(StatusText5);
          //$("#PaymentStatus2_5").addClass("sr-only");
          $("#PaymentStatus5 br").addClass("sr-only");
        }
        $("#PaymentStatus1_5").html(StatusText5);
        
        
        if (res04_type05[0].TransferedDate != null && res04_type05[0].TransferedDate != "") {
          let v: any = this.translate.get("Date of payment")
          $("#PaymentStatus2_5").html(v.value + " " + this.Util.transformDate((new Date(res04_type05[0].TransferedDate.substring(0, 10))).toISOString(), "short"));
          $("#divPaymentStatus").removeClass("sr-only");
        }
      }else{

        let res05Type05 = Rec05.filter((a: any) => a.RequestTypeCode == 5);
        let StatusText5: string = "ยื่นอุทธรณ์";
        if (res05Type05.length > 0){
          if (res05Type05[0].Result == "จ่ายเพิ่ม"){
            StatusText5 += " จ่ายคืนเงินคุ้มครองเพิ่มเติม จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type05[0].FinallyReimbursible) ? 0 : res05Type05[0].FinallyReimbursible)) + " บาท";
          }
          if (res05Type05[0].Result == "เท่าเดิม"){
            StatusText5 += " จ่ายคืนเงินคุ้มครองเท่าเดิม";
          }
          if (res05Type05[0].Result == "เรียกคืน"){
            StatusText5 += " เรียกคืนเงินฝาก จำนวนเงิน " + this.Util.numberWithCommas(this.FormatNumber(isNaN(res05Type05[0].FinallyReimbursible) ? 0 : res05Type05[0].FinallyReimbursible)) + " บาท";
          }
          
          $("#PaymentStatus1_5").html(StatusText5);
          $("#PaymentStatus2_5").addClass("sr-only");
          $("#PaymentStatus5 br").addClass("sr-only");
        }
        else{
          $("#PaymentStatus5").addClass("sr-only");
        }

      }

      
      
    }
    if (this.ContactDros.CRM03 != null || this.ContactDros.CRM03.length != 0) {
      LastDate = null;
      this.ContactDros.CRM03.forEach((a: any) => {
        if (LastDate == null) {
          Rec03 = a;
          LastDate = new Date(a.ModifyDate.substring(0, 19));
        }
        else if (LastDate < new Date(a.ModifyDate.substring(0, 19))){
          Rec03 = a;
          LastDate = new Date(a.ModifyDate.substring(0, 19));
        }
      });
      $("#Status1").html(Rec03.StatusDefinitionCustPortal);
      $("#Status2").html("วันที่ " + this.Util.transformDate(LastDate.toISOString().substring(0, 10), "short"));
    }

    $("#divBankList").addClass("sr-only");
    $("#divSummary").removeClass("sr-only");
    await this.ReqAdditionalDoc();
    await this.InvestigateAndAppealCondition(BankCode);
  }

  async InvestigateAndAppealCondition(BankCode: any) {
    if(this.Contact.dpa_ndidflag == true)
    {
        if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM06)) {
        let result: any = await this.Api.postCustomApi("Dros", "webAuth", { uid: this.ContactDros.CRM06.UID }); 
        if(!this.Util.IsNullOrUndefined(result) && result.length > 0  )
        {
        if (!this.Util.IsNullOrUndefined(result[0].resultCode) && result[0].resultCode == "00") {
          if (!this.Util.IsNullOrUndefined(result[0].links) && result[0].links.length > 0) {

            console.log(result);
            this.drosWeb = result[0].links[0].webURL;
              if(result[0].actiontype ==1 ) { 
                $("#lblInvestigate").html("แจ้งช่องทางการรับเงิน"); 
              }
              else if(result[0].actiontype == 2 ) {
                $("#lblInvestigate").html("ยื่นคำขอรับเงิน");    
              }
              else if(result[0].actiontype == 4 ) {
                $("#lblInvestigate").html("ยื่นขอตรวจสอบ");  
              }
              else if(result[0].actiontype == 5 ) {
                $("#lblInvestigate").html("ยื่นอุทธรณ์");   
              }
              else {
                $("#lblInvestigate").html("ยื่นอุทธรณ์");  
              }
            
            $("#btnInvestigate").removeClass("sr-only");
          }
            else {
              $("#btnInvestigate").addClass("sr-only");
            }
          }
          else {
            let para = "ResultCode=" + result[0].resultCode;
            let tmp: any = await this.Api.get("crmservice", "getErrorCode", para); 
            if(!this.Util.IsNullOrUndefined(tmp.ResultMessage))
            {
              this.Util.WarningDialog(tmp.ResultMessage);
            }
            else{
              this.Util.WarningDialog("ระบบขัดข้อง ไม่สามารถใช้งานได้ชั่วคราว");
              $("#btnInvestigate").addClass("sr-only");
              $("#btnAdditionalDoc").addClass("sr-only");
              $("#btnsentmaildoc").addClass("sr-only");
            }
            $("#btnInvestigate").addClass("sr-only");
          }
        }
        else  {
          $("#btnInvestigate").addClass("sr-only");
        }
      }
    }
  

    /* let BankList: any = await this.Api.get("master", "bank");
     let Bank: any = BankList.filter((a: any) => a.dpa_bankcode == BankCode)[0];
     let LastDate: any = null;
     let EffectiveDate: any;
     if (Bank.dpa_effectivedate != null && Bank.dpa_effectivedate != "") {
       EffectiveDate = new Date(Bank.dpa_effectivedate.substring(0, 10));
       let CRM03 = this.ContactDros.CRM03.filter((a: any) => a.RequestedNo.substring(0, 1) == "I");
       CRM03.forEach((a: any) => {
         if (LastDate == null) {
           LastDate = new Date(a.ModifyDate.substring(0, 10));
         }
         else if (LastDate < new Date(a.ModifyDate.substring(0, 10))) {
           LastDate = new Date(a.ModifyDate.substring(0, 10));
         }
       });
 
       let Diff = this.DateDiff(EffectiveDate, new Date());
       if (this.Contact.dpa_investigateflag == null || this.Contact.dpa_investigateflag == false) {
         if (Diff >= 31 && Diff <= 45) {
           $("#lblInvestigate").html("ขอตรวจสอบ");
           this.InvestigateFlag = true;
         }
         else {
           $("#btnInvestigate").addClass("sr-only");
         }
       }
       else {
         if (this.Contact.dpa_resultinvestflag == null || this.Contact.dpa_resultinvestflag == false) {
           $("#lblInvestigate").html("ขอตรวจสอบ");
           if (Diff >= 31 && Diff <= 45)
             $("#btnInvestigate").attr("disabled", "disabled");
           else
             $("#btnInvestigate").addClass("sr-only");
         }
         else {
           let InvResultDate = new Date(this.Contact.dpa_resultinvestdate.substring(0, 10));
           LastDate = new Date();
           if (this.DateDiff(InvResultDate, new Date()) <= 30) {
             if (this.Contact.dpa_appealflag != null && this.Contact.dpa_appealflag == true)
               $("#btnInvestigate").attr("disabled", "disabled");
             this.AppealFlag = true;
           }
           else {
             $("#btnInvestigate").addClass("sr-only");
           }
         }
       }
     }
     else {
       $("#btnInvestigate").addClass("sr-only");
     }
     */
  }


  async CreateTable1() {
    this.router.navigate(["singlegatewaywait2"]);
  }

  async ReqAdditionalDoc() {
    if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM03)) {
      let selected = this.ContactDros.CRM03.filter((a: any) => a.FilePath != null && a.FilePath != "" && a.FilePath.split('_')[1] == "05.pdf");
      let arr1 = selected.map((obj: any) => { return { ...obj, date: new Date(obj.ModifyDate) }; });
      let arr2 = this.ContactDros.CRM03.map((obj: any) => { return { ...obj, date: new Date(obj.ModifyDate) }; });
      let sortedDesc = arr1.sort((objA: any, objB: any) => objB.date.getTime() - objA.date.getTime());
      let sortedDescAll = arr2.sort((objA: any, objB: any) => objB.date.getTime() - objA.date.getTime());
      if (sortedDesc.length > 0) {
        if(sortedDescAll.length > 0 )
        {
          if(sortedDesc[0].ModifyDate == sortedDescAll[0].ModifyDate)
          {
            this.PathPdf = sortedDesc[0].FilePath;
            $("#btnAdditionalDoc").removeClass("sr-only");
          }
          else
          {
            $("#btnAdditionalDoc").addClass("sr-only");

          } 
        }
        else
        {
          $("#btnAdditionalDoc").addClass("sr-only");
        }
      }
      else {
        $("#btnAdditionalDoc").addClass("sr-only");
      }
    }
    else {
      $("#btnAdditionalDoc").addClass("sr-only");
    }

    if(!this.Util.IsNullOrUndefined(this.ContactDros.CRM03))
    {
      let crm03file = this.ContactDros.CRM03.filter((a: any) => a.FilePath != null);
      if (crm03file != null && crm03file.length > 0) { 
          $("#btnsentmaildoc").removeClass("sr-only");
        }
      else
      {
        $("#btnsentmaildoc").addClass("sr-only");
      }
    }
    else{
      $("#btnsentmaildoc").addClass("sr-only");
    }

  }

  async openPDF(pdfPath: string) {
    if(pdfPath != "")
    {
    let para = "FilePath=" + pdfPath;
    let tmp: any = await this.Api.get("crmservice", "getFileDROS2", para); 
    let fileName: any = pdfPath.split('/');
    var vfilename = fileName[fileName.length -1];
    var objbuilder = '';
    const linkSource = tmp.File;
    console.log(tmp.size)
   /*objbuilder += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
    objbuilder += (linkSource);
    objbuilder += ('" type="application/pdf" class="internal">');
    objbuilder += ('<embed src="data:application/pdf;base64,');
    objbuilder += (linkSource);
    objbuilder += ('" type="application/pdf"  />');
    objbuilder += ('</object>');

    var win = window.open("#","_blank");
    var title = "my tab title";
    win.document.write('<html><title>'+ title +'</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">');
    win.document.write(objbuilder);
    win.document.write('</body></html>');  


    var objbuilder2 = '';
    const linkSource2 = encodeURI(tmp.File);
    console.log(tmp.size)
    objbuilder2 += ('<object width="100%" height="100%" data="data:application/pdf;base64,');
    objbuilder2 += (linkSource2);
    objbuilder2 += ('" type="application/pdf" class="internal">');
    objbuilder2 += ('<embed src="data:application/pdf;base64,');
    objbuilder2 += (linkSource2);
    objbuilder2 += ('" type="application/pdf"  />');
    objbuilder2 += ('</object>');

    var win3 = window.open("#","_blank");
    var title3 = "my tab title3";
    win3.document.write('<html><title>'+ title3 +'</title><body style="margin-top: 0px; margin-left: 0px; margin-right: 0px; margin-bottom: 0px;">');
    win3.document.write(objbuilder2);
    win3.document.write('</body></html>');  */

    const win2 = window.open("","_blank");
    let html = '';

    html += '<html><head><title>' + vfilename + '</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>' ;
    html += '<body style="margin:0!important">';
    html += '<embed width="100%" height="100%" src="data:application/pdf;base64,'+encodeURI(linkSource)+'" type="application/pdf" />';
    html += '</body>';
    html += '</html>'; 
    
    setTimeout(() => {
          win2.document.write(html);
        }, 0);
        
       /*
        var file = new Blob([tmp.File], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);*/


    }
    else{
      this.Util.WarningDialog("ไม่มีข้อมูลการขอเอกสารเพิ่มจากสถาบันคุ้มครองเงินฝาก");
    }
  }

  Back() {
    $("#divBankList").removeClass("sr-only");
    $("#divSummary").addClass("sr-only");
  }

  PDF() {
    // For test purpose
    let FileName: any = "";
    let IDNo = this.Ticket.dpa_idcard == null ? this.Ticket.dpa_registrationid == null ? this.Ticket.dpa_passport : this.Ticket.dpa_registrationid : this.Ticket.dpa_idcard;
    switch (IDNo) {
      case "9442643182995": FileName = "202103190001_STATEMENT.pdf"; break;
      case "6932044986885": FileName = "202103190002_STATEMENT.pdf"; break;
      case "105513001952": FileName = "202103190003_STATEMENT.pdf"; break;
      case "105513001953": FileName = "202103190004_STATEMENT.pdf"; break;
      case "1532781893998": FileName = "202103190005_STATEMENT.pdf"; break;
      case "2138007773113": FileName = "202103190006_STATEMENT.pdf"; break;
      case "5506495856063": FileName = "2021032200001_STATEMENT.pdf"; break;
      case "9658097573669": FileName = "2021032200002_STATEMENT.pdf"; break;
      case "105514006644": FileName = "2021032200003_STATEMENT.pdf"; break;
      case "2219787820779": FileName = "2021032300001_STATMENT.pdf"; break;
      case "8883211078728": FileName = "2021032300002_STATMENT.pdf"; break;
      case "7485595890162": FileName = "2021032300003_STATMENT.pdf"; break;
      case "MM1234561": FileName = "2021032300004_STATMENT.pdf"; break;
      case "MM1234562": FileName = "2021032300005_STATMENT.pdf"; break;
      case "MM1234563": FileName = "2021032300006_STATMENT.pdf"; break;
      case "105517012921": FileName = "2021032300007_STATMENT.pdf"; break;
      case "105520001081": FileName = "2021032300008_STATMENT.pdf"; break;
      case "105520001082": FileName = "2021032300009_STATMENT.pdf"; break;
      case "7595816874309": FileName = "2021032400001_STATEMENT.pdf"; break;
      case "9442643182995": FileName = "2021032400002_STATEMENT.pdf"; break;
      case "6932044986885": FileName = "2021032400003_STATEMENT.pdf"; break;
      case "9676233842512": FileName = "202110149676233842512-STM.pdf"; break;
      case "3509900002059": FileName = "202110143509900002059_STM.pdf"; break;
    }
    window.open("assets/dist/pdf/" + FileName, "_blank");
    //window.open("../assets/dist/pdf/202111490001_STATEMENT.pdf", "_blank");
  }

  FormatNumber(Num: Number) {
    try {
      return Num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
    catch (e) {
      return Num
    }
  }

  DateDiff(d1: any, d2: any) {
    let dt1 = new Date(d1);
    let dt2 = new Date(d2);
    return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24)) + 1;
  }

  ClearText() {
    $("#FirstNameDOPA").val("");
    $("#LastNameDOPA").val("");
    $("#IDNoDOPA").val("");
    $("#LaserNoDOPA").val("");
    $("#BirthDateDOPA").val("");
    $("#PhoneNoDOPA").val("");
  }

  SetState(State: any) {
    let CookieData: any = localStorage.getItem("dpa_portal");
    if (CookieData == null || CookieData == "") {
      return;
    }
    CookieData = JSON.parse(CookieData);
    CookieData.refundState = State;
    localStorage.setItem("dpa_portal", JSON.stringify(CookieData));
  }

  async GetState() {
    let CookieData: any = localStorage.getItem("dpa_portal");
    if (CookieData == null || CookieData == "") {
      return "";
    }
    CookieData = JSON.parse(CookieData);
    return CookieData.refundState == null || CookieData.refundState == undefined ? "" : CookieData.refundState;
  }

  GotoState(State: any) {
    $("#divStart").addClass("sr-only");
    $("#divStart2").addClass("sr-only");
    $("#divOTP").addClass("sr-only");
    if (State.toLowerCase() == "skipotp") {
      this.SubmitOTP();
    }
    else if (State.toLowerCase() == "consent") {
      this.ShowConsentForm();
    }
    else if (State.toLowerCase() == "banklist") {
      this.ShowBankList();
    }
  }

  numberAndAlphabetOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (!(charCode > 47 && charCode < 58) && // numeric (0-9)
      !(charCode > 64 && charCode < 91) && // upper alpha (A-Z)
      !(charCode > 96 && charCode < 123)) { // lower alpha (a-z)
      return false
    }
    return true
  }

  async RequestOTP() {
    try {
      let ParamObj: any = {
        MobileNo: this.Contact.telephone1
      };
      let Res: any = await this.Api.postCustomApi("Crm", "RequestOTP", ParamObj);
      if (this.Util.isSuccessResponse(Res)) {
        //Res = this.Util.AesDecryptDictValue(Res.json());
        this.OTPRefCode = Res.RefCode; 
        $("#OTPRefCode").html(Res.RefCode); 
        let Msg = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : "
        Msg += Res.otpNo + " "
        Msg += "(RefCode : " +Res.RefCode  
        Msg += ") (รหัสมีอายุ " + Res.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น"  

        ParamObj = {
          dpa_phoneno: this.Contact.telephone1,
          dpa_description: Msg
        };
        let SmsRes: any = this.Api.post("crmservice", "sendSms", ParamObj);

        $("#btnSubmitOTP").removeAttr("disabled");
        if (Res.expInMinute == undefined || Res.expInMinute == null) {
          this.TotalTime = 300;
        }
        else {
          this.TotalTime = Res.expInMinute * 60;
        }
        this.ElapseTime = 0;
        if (this.SubScr != undefined) {
          this.SubScr.unsubscribe();
        }
        this.SubScr = timer(0, 1000).subscribe(() => this.CountDownOTP());
        this.WaitTime = 60;
        $("#btnRequestOTP").attr("disabled", "disabled");
        if (this.SubScr2 != undefined) {
          this.SubScr2.unsubscribe();
        }
        this.SubScr2 = timer(0, 1000).subscribe(() => this.CountDownWaitTime());
      }
      else {
        $("#btnSubmitOTP").attr("disabled", "disabled");
        this.Util.ShowWaiting(false);
        this.Util.WarningDialog("เกิดข้อผิดพลาดในการขอรหัส OTP กรุณาติดต่อผู้ดูแลระบบ");
      }
    }
    catch (err) {
      $("#btnSubmitOTP").attr("disabled", "disabled");
      this.Util.ShowWaiting(false);
      this.Util.WarningDialog("เกิดข้อผิดพลาดในการขอรหัส OTP กรุณาติดต่อผู้ดูแลระบบ");
    }
  }

  CountDownOTP() {
    if (this.ElapseTime == 0 && this.TotalTime == 0) {
      this.SubScr.unsubscribe();
      return;
    }
    if (this.ElapseTime == this.TotalTime) {
      this.SubScr.unsubscribe();
      $("#btnSubmitOTP").attr("disabled", "disabled");
      $("#btnSubmitOTP").html("ยืนยัน");
      this.ElapseTime = 0;
      return;
    }

    this.ElapseTime++;
    let RemainingSecs = this.TotalTime - this.ElapseTime;
    let RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
    RemainingSecs = RemainingSecs % 60;
    $("#btnSubmitOTP").html("ยืนยัน " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs);
  }

  CountDownWaitTime() {
    if (this.WaitTime == 0) {
      $("#btnRequestOTP").html("ขอรหัสอีกครั้ง");
      $("#btnRequestOTP").removeAttr("disabled");
      this.SubScr2.unsubscribe();
      return;
    }
    this.WaitTime--;
    $("#btnRequestOTP").html("ขอรหัสอีกครั้ง " + this.WaitTime);
  }

  GetStatusGuidByCode(code: string) {
    let found: any = this.masterStatus.filter((s: any) => {
      return s.dpa_code == code
    })

    if (found != null && found.length > 0) {
      return found[0].dpa_approvalstatusid
    }
    else {
      return null
    }
  }

  sentmailDoc()
  {
    
    this.Util.ShowWaiting(true);
    if (!this.Util.IsNullOrUndefined(this.ContactDros.CRM06.IDNo)) 
    { 
      let ParamObj: any = {
        idno: this.ContactDros.CRM06.IDNo ,
        email: this.Contact.emailaddress1 
      };
      let res: any = this.Api.post("crmservice", "SendDocument", ParamObj);
      console.log(res)
      if (this.Util.isSuccessResponse(res)) { 
        this.Util.SuccessDialog("บันทึกข้อมูลสำเร็จ") 
      }
      else{
        this.Util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ") 
      }
    }
    
    this.Util.ShowWaiting(false);

  }

  GetErrorMsgCheckCard(obj: any): string {
    let msg = ""
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        if (Array.isArray(obj[prop]) && obj[prop] != null && obj[prop].length > 0) {
          obj[prop].forEach((m: string) => {
            msg = msg == "" ? m : msg + ", " + m
          });
        }
        else if (typeof obj[prop] == "string") {
          msg = msg == "" ? obj[prop] : msg + ", " + obj[prop]
        }
      }
    }
    return msg
  }

  
  ngOnDestroy(){
    //prevent memory leak when component destroyed
    if (this.SubScr != undefined) {
      this.SubScr.unsubscribe();
    } 
    if (this.SubScr2 != undefined) {
      this.SubScr2.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/refund-deposits/refund-deposits.component.ts